<template>
  <div class="portlet_form">
  
    <div class="portlet_content">
      <div class="topWrap">
        <div class="tit">Sep 2019</div>
        <div class="btnWrap">
          <sui-button type="button" class="btn_pre">pre</sui-button>
          <sui-button type="button" class="btn_next">next</sui-button>
        </div>
        <div class="topWrapR">
          <sui-button type="button" class="btn_ico_day_on">date</sui-button>
          <sui-button type="button" class="btn_ico_month_off">month</sui-button>
        </div>
      </div>
      <div class="bodyWrap">
          <ul class="day">
            <li>
              <div class="date"><span class="today"></span>8<span class="week">S</span></div>
              <div class="special">정기휴무</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="public">공휴일</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="event">사업장행사</div>
            </li>
            <li>
              <div class="date"><span class="today"></span>21<span class="week">F</span></div>
              <div class="event">내생일</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="special">창립기념일</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="event">미팅</div>
            </li>
            <li>
              <div class="date">25<span class="week">T</span></div>
              <div class="event">자선바자회</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="event">자선바자회</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="event">자선바자회</div>
            </li>
            <li>
              <div class="date"></div>
              <div class="event">자선바자회</div>
            </li>
         </ul>
      </div>
    </div>
    <div class="portlet_bottom">
      <!-- <div class="left">
        <sui-button type="button" class="btn_txt_GR_arrow">상세보기</sui-button>
      </div> -->
      <div class="right">
        <span :class="pageItem.homeCardTypeCode === 'D' ? 'ico_dashboard' : 'ico_notice'">
          pageItem.homeCardTypeName 
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMY_00030', // eslint-disable-line vue/name-property-casing
  props: {
    pageItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Codes
      COD_PAGE_UE: { label: '', key: '' },
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped>
.portlet_form {
  width:312px;
  height:300px;
}
.portlet_tit {height:66px}
.portlet_tit .tt_tit {
  margin:18px 28px 0 28px;
  font-size:16px;
  color: #333;
  font-weight:500;
  line-height:24px;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.portlet_content {
  /*height:100%;*/
  height:256px;
  overflow: hidden;
}
.topWrap {display:inline-flex;width:100%;padding:18px 28px;line-height:20px;}
.topWrap .tit {font-size:16px; color:#333;}
.topWrap .btnWrap {padding-left:5px;line-height:15px;}
.btn_pre {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    background:url('../../../../assets/images/btn_prev_normal.png') no-repeat center center
}
.btn_pre:hover {background:url('../../../../assets/images/btn_prev_hover.png') no-repeat center center}
.btn_next {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    background:url('../../../../assets/images/btn_next_normal.png') no-repeat center center
}
.btn_next:hover {background:url('../../../../assets/images/btn_next_hover.png') no-repeat center center}
.topWrap .topWrapR {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin-left: auto;
}
.topWrapR button {margin-left:-1px}
.topWrapR .btn_ico_day_on {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    border: 1px solid #ccc;
    background:url('../../../../assets/images/ic_calendar_list_selected.png') no-repeat center center #f7f7f7
}
.topWrapR .btn_ico_month_on {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    border: 1px solid #ccc;
    background:url('../../../../assets/images/ic_calendar_grid_selected.png') no-repeat center center #f7f7f7
}
.topWrapR .btn_ico_day_off {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    border: 1px solid #eaeaea;
    background:url('../../../../assets/images/ic_calendar_list_normal.png') no-repeat center center #fff
}
.topWrapR .btn_ico_month_off {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    border: 1px solid #eaeaea;
    border-left: 1px solid #ccc;
    background:url('../../../../assets/images/ic_calendar_grid_normal.png') no-repeat center center #fff
}

/***********  day  ********************/
.bodyWrap {width:310px}
.bodyWrap .day {height:192px;overflow:hidden;overflow-y:auto; width:100%;padding: 0 11px 0 28px;}
.bodyWrap .day li {display:inline-flex;width:100%;height:34px;margin-bottom:4px}
.bodyWrap .day .date {
  display:flex;
  position:relative;
  justify-content: center;
  font-size: 16px;
  color: #333;
  width: 20px;
  align-items: flex-start;
  height: 34px;
  flex-wrap: nowrap;}
.bodyWrap .day .date span.today:before {
  display: inline-block;
  content: '';
  width: 4px;
  height:4px;
  border-radius: 20px;
  background-color: #ff5858;
  position:relative;
  left:-5px;
  top: -10px;
}
.bodyWrap .day .date span.week{
  margin-top:20px;
  font-size: 10px;
  color: #767676;
  text-align: center;
  position: absolute;
  left:9px
}
.bodyWrap .day .special {
  width:220px;
  display:flex;
  justify-content:flex-start;
  align-items: center;
  padding-left: 20px;
  margin-left:auto;
  font-size:12px;
  color:#333;
  border-left:2px solid #6952db;
  background-color:#E1DCF8;
}
.bodyWrap .day .public  {
  width:220px;
  display:flex;
  justify-content:flex-start;
  align-items: center;
  padding-left:20px;
  margin-left:auto;
  font-size:12px;
  color:#333;
  border-left:2px solid #0ebb59;
  background-color:#D2F2E0
}
.bodyWrap .day .event   {
  width:220px;
  display:flex;
  justify-content:flex-start;
  align-items: center;
  padding-left: 20px;
  margin-left:auto;
  font-size:12px;
  color:#333;
  border-left:2px solid #73a2ff;
  background-color:#E3ECFF}
/*******************/

.portlet_bottom {
  display:inline-flex;
  margin-top: auto;
  width:100%;
  line-height:40px;
}
.portlet_bottom .left{justify-content: flex-start;margin-left:28px;}
.portlet_bottom .right {justify-content: flex-end;margin-left:auto;margin-right:28px}
.btn_txt_GR_arrow  {
  font-size: 12px;
  color:#333;
  font-weight:normal;
  padding-right:10px;
  background:url('../../../../assets/images/ic_hyperling_blue_disable.png') no-repeat right 7px}
.portlet_bottom .right .ico_todo {
  font-size:10px;
  color:#a5a5a5;
  padding-right:20px;
  width:16px;
  height:16px;
  background:url('../../../../assets/images/ic_todo_tag_off.png') no-repeat 98% 2px;
}
.portlet_bottom .right .ico_dashboard {
  font-size:10px;
  color:#a5a5a5;
  padding-right:20px;
  width:16px;
  height:16px;
  background:url('../../../../assets/images/ic_dashboard_tag_off.png') no-repeat 98% 2px;
}
.portlet_bottom .right .ico_notice {
  font-size:10px;
  color:#a5a5a5;
  padding-right:20px;
  width:16px;
  height:16px;
  background:url('../../../../assets/images/ic_notice_tag_off.png') no-repeat 98% 2px;
}
</style>
